import { render, staticRenderFns } from "./editarCliente.vue?vue&type=template&id=06143e02&"
import script from "./editarCliente.vue?vue&type=script&lang=js&"
export * from "./editarCliente.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports